import { SvgIcon, SvgIconProps } from '@mui/material';

interface WisdomLogoIconProps extends SvgIconProps {
  playAnimation?: boolean;
}

export const WisdomLogoIcon = ({
  playAnimation = false,
  ...svgIconProps
}: WisdomLogoIconProps) => {
  return (
    <SvgIcon viewBox="0 0 96 96" {...svgIconProps}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.01637 8.859C0 15.922 0 26.5606 0 47.838C0 69.1154 0 79.754 6.01637 86.817C6.8867 87.8387 7.83727 88.7893 8.859 89.6596C15.922 95.676 26.5606 95.676 47.838 95.676C69.1154 95.676 79.754 95.676 86.817 89.6596C87.8387 88.7893 88.7893 87.8387 89.6596 86.817C95.676 79.754 95.676 69.1154 95.676 47.838C95.676 26.5606 95.676 15.922 89.6596 8.859C88.7893 7.83727 87.8387 6.8867 86.817 6.01637C79.754 0 69.1154 0 47.838 0C26.5606 0 15.922 0 8.859 6.01637C7.83727 6.8867 6.8867 7.83727 6.01637 8.859ZM85.5 58.5V24L83.7929 22.2929C83.6054 22.1054 83.351 22 83.0858 22H77C76.1716 22 75.5 22.6716 75.5 23.5V42.8787C75.5 44.215 73.8843 44.8843 72.9393 43.9393L51.4393 22.4393C51.158 22.158 50.7765 22 50.3787 22H45C44.1716 22 43.5 22.6716 43.5 23.5V42.8787C43.5 44.215 41.8843 44.8843 40.9393 43.9393L19.4393 22.4393C19.158 22.158 18.7765 22 18.3787 22H12.5C11.6716 22 11 22.6716 11 23.5V51.5L11.8257 50.9496C12.2188 50.6875 12.7417 50.7363 13.0795 51.0666L34.5628 72.0725C34.8431 72.3466 35.2195 72.5 35.6115 72.5H42C42.8284 72.5 43.5 71.8284 43.5 71V52.6759C43.5 51.3319 45.1315 50.6662 46.0718 51.6265L66.5588 72.5494C66.841 72.8376 67.2273 73 67.6306 73H74C74.8284 73 75.5 72.3284 75.5 71.5V52.494C75.5 51.1761 77.0777 50.4988 78.0331 51.4065L85.5 58.5Z"
        fill="url(#paint0_linear_695_7180)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_695_7180"
          x1="6.5"
          y1="6.5"
          x2="88.5"
          y2="93"
          gradientUnits="userSpaceOnUse"
        >
          {playAnimation ? (
            <>
              <stop stopColor="#B206CE">
                <animate
                  attributeName="stop-color"
                  values="#B206CE; #7357F6; #83A9F3; #B206CE"
                  dur="3s"
                  repeatCount="indefinite"
                />
              </stop>
              <stop offset="0.489062" stopColor="#7357F6">
                <animate
                  attributeName="stop-color"
                  values="#7357F6; #83A9F3; #B206CE; #7357F6"
                  dur="3s"
                  repeatCount="indefinite"
                />
              </stop>
              <stop offset="1" stopColor="#83A9F3">
                <animate
                  attributeName="stop-color"
                  values="#83A9F3; #B206CE; #7357F6; #83A9F3"
                  dur="3s"
                  repeatCount="indefinite"
                />
              </stop>
            </>
          ) : (
            <>
              <stop stopColor="#B206CE" />
              <stop offset="0.489062" stopColor="#7357F6" />
              <stop offset="1" stopColor="#83A9F3" />
            </>
          )}
        </linearGradient>
      </defs>
    </SvgIcon>
  );
};
